module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "holder"
    }
  }, [_c('div', {
    staticClass: "mapHolder"
  }, [_c('us-map', {
    on: {
      "stateSelected": _vm.onStateSelected,
      "stateDeselected": _vm.onStateDeselected
    }
  })], 1), _vm._v(" "), (_vm.currentState) ? _c('tooltip', {
    attrs: {
      "title": _vm.currentState.Name,
      "description": _vm.currentStateDescription
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39fd153a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/d3-components/basic-map-tooltip/index.vue
// module id = 123
// module chunks = 1